import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import {
  MenuComponent,
  MobileMenuComponent,
  FabMenuComponent,
  GlobalNotificationBannerComponent,
  FinePrintComponent,
  FooterComponent,
  ChatComponent
} from '@tdwb/core';
import { LayoutComponent } from './layout.component';
import { ResponsiveOptionComponent } from './responsive-option.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    MenuComponent,
    MobileMenuComponent,
    FabMenuComponent,
    GlobalNotificationBannerComponent,
    FinePrintComponent,
    FooterComponent,
    ChatComponent
  ],
  exports: [
    LayoutComponent,
    ResponsiveOptionComponent
  ],
  declarations: [
    LayoutComponent,
    ResponsiveOptionComponent
  ],
  providers: []
})
export class LayoutModule {
}
